import { IconButton, Stack, useTheme } from "@mui/material";
import { CircleUserRound, User } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { DashboardHeaderActions } from "web_myplann/Dashboard/Components/DashboardHeaderActions";
import { useIsDashboardV2 } from "web_myplann/Dashboard/State/dashboardVariantContext";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import NavigationHeader from "web_myplann/Shared/Header/NavigationHeader";

type DashboardEmptyHeaderProps = {
	title: string;
};

export const DashboardEmptyHeader = ({ title }: DashboardEmptyHeaderProps) => {
	const { palette } = useTheme();
	const navigate = useNavigate();
	const isDashboardV2 = useIsDashboardV2();
	const ProfileIcon = isDashboardV2 ? User : CircleUserRound;

	return (
		<NavigationHeader
			title={title}
			disableBottomPadding
			startComponent={
				<IconButton
					sx={{ padding: 0 }}
					onClick={() => {
						navigate(Routing.Profile.ProfileDetail.path());
					}}
				>
					<ProfileIcon color={palette.deprecated.grey[700]} />
				</IconButton>
			}
			endComponent={
				<Stack direction="row" gap={1.6}>
					<DashboardHeaderActions variant="flat" />
				</Stack>
			}
		/>
	);
};
